import { AbstractInteractionsProvider } from "@aws-amplify/interactions/lib/Providers";
import * as LexRuntime from "aws-sdk/clients/lexruntime";
import { ConsoleLogger as Logger } from "@aws-amplify/core/lib";
import { Auth } from "aws-amplify";

const logger = new Logger("AWSLexProvider");

export class EVInteractionProvider extends AbstractInteractionsProvider {
  constructor(options = {}) {
    super(options);
    this.aws_lex = new LexRuntime({ region: this._config.region });
    this._botsCompleteCallback = {};
  }

  getProviderName() {
    return "EVInteractionsProvider";
  }

  getCategory() {
    return "Interactions";
  }

  _sendMessage({ message, params, res, rej, botname }) {
    const { options = {}, content } = message;
    const userId = options["userId"];

    const contentParams = {
      ...params,
      userId: userId
    };

    if (options.requestAttributes) {
      contentParams.requestAttributes = options.requestAttributes;
    }
    if (options.sessionAttributes) {
      contentParams.sessionAttributes = options.sessionAttributes;
    }

    if (options["messageType"] === "voice") {
      console.log(contentParams);
      contentParams.contentType = "audio/x-l16; sample-rate=16000";
      contentParams.inputStream = content;
      contentParams.accept = "audio/mpeg";

      logger.debug("postContent to lex", message);
      this.aws_lex.postContent(contentParams, (err, data) => {
        this.responseCallback(err, data, res, rej, botname);
      });
    } else if (options["messageType"] === "transcript") {
      console.log(contentParams);
      contentParams.contentType = "text/plain; charset=utf-8";
      contentParams.inputStream = content;
      contentParams.accept = "audio/mpeg";

      logger.debug("postContent to lex", message);
      this.aws_lex.postContent(contentParams, (err, data) => {
        this.responseCallback(err, data, res, rej, botname);
      });
    } else {
      contentParams.inputText = content;
      logger.debug("postContent to lex", message);
      this.aws_lex.postText(contentParams, (err, data) => {
        this.responseCallback(err, data, res, rej, botname);
      });
    }
  }

  sendMessage(botname, message) {
    // eslint-disable-next-line no-undef
    return new Promise(async (res, rej) => {
      if (!this._config[botname]) {
        return rej("Bot " + botname + " does not exist");
      }

      const credentials = await Auth.currentCredentials();
      if (!credentials) {
        return rej("No credentials");
      }
      this.aws_lex = new LexRuntime({ region: this._config[botname].region, credentials });

      let params;
      params = {
        botAlias: this._config[botname].alias,
        botName: botname
      };

      this._sendMessage({ message, botname, params, res, rej });
    });
  }

  responseCallback(err, data, res, rej, botname) {
    if (err) {
      rej(err);
      return;
    } else {
      // Check if state is fulfilled to resolve onFullfilment promise
      logger.debug("postContent state", data.dialogState);
      if (data.dialogState === "ReadyForFulfillment" || data.dialogState === "Fulfilled") {
        if (typeof this._botsCompleteCallback[botname] === "function") {
          setTimeout(() => this._botsCompleteCallback[botname](null, { slots: data.slots }), 0);
        }

        if (this._config && typeof this._config[botname].onComplete === "function") {
          setTimeout(() => this._config[botname].onComplete(null, { slots: data.slots }), 0);
        }
      }

      res(data);
      if (data.dialogState === "Failed") {
        if (typeof this._botsCompleteCallback[botname] === "function") {
          setTimeout(() => this._botsCompleteCallback[botname]("Bot conversation failed"), 0);
        }

        if (this._config && typeof this._config[botname].onComplete === "function") {
          setTimeout(() => this._config[botname].onComplete("Bot conversation failed"), 0);
        }
      }
    }
  }

  onComplete(botname, callback) {
    if (!this._config[botname]) {
      throw new ErrorEvent("Bot " + botname + " does not exist");
    }
    this._botsCompleteCallback[botname] = callback;
  }
}
